import Image from 'next/image';
import { ProductDetails } from '@peerless/data-access/cart-service';
import { ProductLink } from './ProductLink';

import { Box } from '@mui/material';

interface Props {
  direction: 'row' | 'column';
  data: ProductDetails;
}

export const ProductAccessoryImage: React.FC<Props> = ({ data, direction }: Props) => {
  const imageSize = direction === 'row' ? 150 : 230;

  return (
    <Box
      sx={{
        position: 'relative',
        minWidth: imageSize,
        height: imageSize,
      }}
    >
      <ProductLink title={data.title} sku={data.sku}>
        <Image src={data.image} alt={data.title} fill style={{ objectFit: 'contain' }} />
      </ProductLink>
    </Box>
  );
};
